import * as React from "react";
import "./GenericRadioInput.css";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion, PossibleAnswerId } from "../../messages/HR";
import { Radio, RadioGroup } from "@blueprintjs/core";
import { GenericInputHeader } from "./GenericInputHeader";
import { HRQuestionTemplateId } from "../../messages/ObjectIds";
import { Globals } from "../../Globals";

interface GenericRadioInputProps {
    hrRadioQuestionWithStatus: HRQuestionWithStatus<HRQuestion.RadioQuestion | HRQuestion.AmericanTestQuestion>;
    isHidden: boolean;
    onChange: (newVal: PossibleAnswerId, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericRadioInput extends React.Component<GenericRadioInputProps> {
    private readonly labelRegex: RegExp;

    constructor(props: GenericRadioInputProps) {
        super(props);
        this.labelRegex = new RegExp(" <br> ", "g");
        if (props.hrRadioQuestionWithStatus.question.chosenAnswerId !== null) {
            return;
        }

        const lastPick = Globals.getAnswerByTemplateId(props.hrRadioQuestionWithStatus.question.textId);
        if (lastPick !== null) {
            this.handleChange(lastPick, props.hrRadioQuestionWithStatus.question.id);
        }
    }

    handleChange(answerId: PossibleAnswerId, questionId: HRQuestionId) {
        this.props.onChange(answerId, questionId);
        this.props.onBlur(questionId);
    }

    render() {
        const question = this.props.hrRadioQuestionWithStatus.question;
        const status = this.props.hrRadioQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <RadioGroup
                    onChange={() => { /* */}}
                >
                    {question.possibleAnswers.map((answer) => {
                        return (
                            <div className="GenericRadioInput__item" key={answer.id}>
                                <Radio
                                    id={HRQuestionTemplateId.unwrap(question.textId)}
                                    onChange={() => this.handleChange(answer.id, question.id)}
                                    checked={answer.id === question.chosenAnswerId}
                                    label={answer.text.replace(this.labelRegex, "\n")}
                                />
                            </div>
                        );
                    })}

                </RadioGroup>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericRadioInput.tsx